import type {
  Aggregations,
  FilterResult,
} from '@xing-com/crate-jobs-domain-search-types';

// Conversational search only supports a subset of filters
const removeUnavailable =
  (isAiSearch: boolean) =>
  (filter: FilterResult | 'salary'): boolean =>
    !isAiSearch || filter === 'salary' || !!filter.isAiCompatible;

export const getFiltersFromAggregations = (
  {
    remoteOptions,
    employmentTypes,
    careerLevels,
    disciplines,
    industries,
    countries,
    cities,
  }: Aggregations,
  isAiSearch: boolean
): Array<'salary' | FilterResult> =>
  (
    [
      {
        options: remoteOptions,
        titleKey: 'JOBS_SEARCH_FILTER_REMOTE_OPTION',
        name: 'remoteOption',
        isAiCompatible: true,
      },
      {
        options: employmentTypes,
        titleKey: 'JOBS_SEARCH_FILTER_EMPLOYMENT_TYPE',
        name: 'employmentType',
        isAiCompatible: true,
      },
      {
        options: careerLevels,
        titleKey: 'JOBS_SEARCH_FILTER_CAREER_LEVEL',
        name: 'careerLevel',
        isAiCompatible: true,
      },
      {
        options: disciplines,
        titleKey: 'JOBS_SEARCH_FILTER_DISCIPLINE',
        name: 'discipline',
      },
      'salary',
      {
        options: industries,
        titleKey: 'JOBS_SEARCH_FILTER_INDUSTRY',
        name: 'industry',
      },
      {
        options: countries,
        titleKey: 'JOBS_SEARCH_FILTER_COUNTRY',
        name: 'country',
      },
      {
        options: cities,
        titleKey: 'JOBS_SEARCH_FILTER_CITY',
        name: 'city',
      },
    ] satisfies Array<'salary' | FilterResult>
  ).filter(removeUnavailable(isAiSearch));
